/* The `signInConstant` object is defining constants related to the Sign In
functionality. It includes the following properties: */
const signInConstant = {
  SIGN_IN_AUTH_TOKEN: 'RlBPVTYxRkFYUTBET0EzRVNFWk06MmNjN2NlMWMtZDBkMi0xMWVhLTg3ZDAtMDI0MmFjMTMwMDAz',
  SIGN_IN_HEADING: 'Sign In',
  EMAIL_CONSTANT: {
    LABEL: 'Business Email',
    INVALID_MESSAGE: 'Please enter valid business email!',
    PLACEHOLDER: 'Enter your registered business email',
  },
  PASSWORD_CONSTANT: {
    LABEL: 'Password',
    TYPE: 'password',
    REQUIRED: 'Password is required!',
    PLACEHOLDER: 'Please enter your password',
  },
  RESET_BUTTON: 'Reset Now!',
  CREATE_NEW_ACCOUNT_BUTTON: 'Create Now!',
  SIGN_IN_BUTTON: 'Continue',
  FORGOT_PASSWORD_TEXT: 'Forgot Password? We can help!',
  CREATE_NEW_BUSINESS_TEXT: 'Looking for a new business?',
  SIGN_IN_MODAL_INVALID_CREDS: 'Invalid Credentials, Please enter valid Email Id and Password.',
};

/* The `regexPattern` constant is defining a regular expression pattern for validating passwords. The
pattern is as follows: */
const regexPattern = {
  PASSWORD_PATTERN: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$!%*?&])([a-zA-Z0-9@#$!%*?&]{8,})$/,
  ACCOUNT_EMAIL_VALIDATE: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  MOBILE_NUMBER_PATTERN: /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i,
};

/* The `forgotPasswordConstant` object is defining constants related to the forgot password
functionality. It includes the following properties: */
const forgotPasswordConstant = {
  EMAIL_VALIDATE: 'EMAIL_VALIDATE',
  EMAIL_VALIDATE_SCREEN: 'EMAIL_VALIDATE_SCREEN',
  OTP_VERIFICATION_SCREEN: 'OTP_VERIFICATION_SCREEN',
  FORGOT_NEW_PASSWORD_SCREEN: 'FORGOT_NEW_PASSWORD_SCREEN',
  FORGOT_PASSWORD_HEADING: 'Forgot Password',
  FORGOT_PASSWORD_STATMENT:
    'Enter the email address you used when you joined and we will send you instructions to reset your password.',
  FORM_CONSTANT: {
    EMAIL: {
      TYPE: 'email',
      REQUIRED: 'Please input your business email!',
      INVALID: 'The input is not valid E-mail!',
      PLACEHOLDER: 'Enter your registered business email',
    },
    SELECT: {
      NAME: 'bizCode',
      LABEL: 'List of Business',
      PLACEHOLDER: 'Select Business',
    },
  },
  FORGOT_PASSWORD_API_ERROR_MESSAGE: 'You have not registered with us, please register your EmailId.',
  OTP_VERIFICATION: 'OTP_VERIFICATION',
  OTP_VERIFICATION_HEADING: 'Verification',
  RESEND_OTP_HEADING: 'Resend Verification',
  OTP_VERIFICATION_STATMENT: 'We have sent verification code over your registered Email-Id. Please enter it below.',
  RESEND_OTP_STATMENT: 'We have sent verification code over your registered Email-Id. Please check your email.',
  NEW_PASSWORD: 'NEW_PASSWORD',
  NEW_PASSWORD_HEADING: 'Create password',
  NEW_PASSWORD_FORM_CONSTANT: {
    PASSWORD: {
      PLACEHOLDER: 'New Password',
      NAME: 'password',
      REQUIRED_MESSAGE: 'Please input your password!',
      PASSWORD_PATTERN_MESSAGE:
        'Password should contain atleast 8 characters with atleast 1 capital letter, 1 small letter, 1 number and 1 special character(., @, $, &, #, *)',
    },
    CONFIRM_PASSWORD: {
      PLACEHOLDER: 'Confirm Password',
      NAME: 'confirm_password',
      REQUIRED_MESSAGE: 'Please confirm your password!',
      MATCH_MESSAGE: 'The new password that you entered do not match!',
    },
  },
  EMAIL_VALIDATE_BUTTON: 'Submit',
  EMAIL_VALIDATE_OTP_BUTTON: 'Send OTP',
  NEW_PASSWORD_BUTTON: 'Done',
  NEW_PASSWORD_INFO: {
    LINE_1: 'Password should contain atleast 8',
    LINE_2: 'characters with atleast 1 capital',
    LINE_3: 'letter, 1 small letter, 1 number',
    LINE_4: 'and 1 special character(. , @, $, &, #, *)',
  },
  ACTIVE_BIZ_ERROR: 'You have not registered with us, please register your EmailId.',
  RESET_PASS_BIZ_SUCCESS: 'Password Reset Successfully',
  RESET_PASS_BIZ_TITLE: 'RESET PASSWORD',
};

/* The `registerBusiness` object is defining constants related to the Register new business
functionality. It includes the following properties: */
const registerBusiness = {
  COMPONENT_TYPE: {
    ACCOUNT_DETAILS: 'accountDetails',
    BUSINESS_DETAILS: 'businessDetails',
    OTP_VERIFICATION: 'otpVerification',
    CREATE_PASSWORD: 'createPassword',
    SUCCESS: 'success',
  },
  HEADING: 'Create New Business',
  ACCOUNT_DETAILS: {
    HEADING: 'Create New Business',
    SUB_HEADING: 'Account Details',
    NAME: {
      PLACEHOLDER: 'Name *',
      REQUIRED: ' Name is required!',
      INVALID: 'Name cannot start with a space or be only spaces!',
    },
    EMAIL: {
      PLACEHOLDER: 'Email Id *',
      REQUIRED: 'EmailId is required!',
      INVALID: 'EmailId is not a valid email!',
    },
    COUNTRY_CODE: {
      OPTIONS: [
        {
          LABEL: 'INDIA(+91)',
          VALUE: '91',
        },
        {
          LABEL: 'US(+1)',
          VALUE: '1',
        },
      ],
    },
    MOBILE: {
      PLACEHOLDER: 'Mobile Number',
    },
    LEGAL: {
      TEXT: 'By creating a business account, you agree to the $Terms of Service$ and $Privacy Policy',
    },
    BUTTON: {
      NEXT: 'Next',
    },
  },
  BUSINESS_DETAILS: {
    HEADING: 'Create New Business',
    SUB_HEADING: 'Business Details',
    BUSINESS_NAME: {
      PLACEHOLDER: 'Business Name *',
      REQUIRED: 'Business name is required!',
      INVALID: 'Business name cannot start with a space or be only spaces!',
    },
    SHORT_DESCRIPTION: {
      PLACEHOLDER: 'Short Description *',
      REQUIRED: 'Business short description is required!',
      INVALID: 'Business short description cannot start with a space or be only spaces!',
    },
    BUSINESS_ADDRESS: {
      PLACEHOLDER: 'Business Address, select from map *',
      REQUIRED: 'Business Address is required!',
    },
    BUTTON: {
      PREV: 'Previous',
      NEXT: 'Next',
      SELECT_LOCATION: 'Use This Location',
    },
  },
  OTP_VERIFICATION: {
    HEADING: 'Verification',
    SUB_HEADING: 'Entered Business Name',
    OTP: {
      REQUIRED: 'Required',
      INVALID: 'Invalid',
    },
    Message: "We've sent verification code over your registered Email-Id. Please enter it below.",
    VIEW_BUSINESS: {
      TEXT: 'View/Edit Business Details.',
      LINK: '',
    },
    BUTTON: {
      VERIFY: 'Verify',
      RESEND: 'Resend',
    },
  },
  CREATE_PASSWORD: {
    HEADING: 'Create New Business',
    SUB_HEADING: 'Create Password',
    PASSWORD_FORMAT:
      'Password should contain atleast 8 characters with atleast 1 capital letter, 1 small letter, 1 number and 1 special character(., @, $, &, #, *).',
    PASSWORD: {
      NAME: 'password',
      PLACEHOLDER: 'Password *',
      REQUIRED: 'Please input your password!',
      INVALID:
        'Password should contain atleast 8 characters with atleast 1 capital letter, 1 small letter, 1 number and 1 special character(., @, $, &, #, *)',
    },
    CONFIRM_PASSWORD: {
      NAME: 'confirm_password',
      PLACEHOLDER: 'Confirm Password *',
      REQUIRED: 'Please confirm your password!',
      INVALID: 'The new password that you entered do not match!',
    },
    BUTTON: {
      DONE: 'Done',
    },
  },
};

const otpConstant = {
  VERIFY_TEXT: 'We have sent verification code over your registered Email-Id. Please enter it below.',
};

/** The `teamsConstant` object is defining constants related to teams functionality. It includes the
`TEAM_LIST_COLUMNS` property, which is an array of objects representing the columns of a team list.
Each object in the array has two properties: `title` and `key`. */
const teamsConstant = {
  TEAM_DETAIL_PAGE_HEADING: {
    HEAD: 'New Team',
    CREATE_SUB_HEAD: 'Create Team',
    EDIT_SUB_HEAD: 'Edit Team',
    TEAM_DETAIL: 'DETAILS',
  },

  TEAM_LIST_PAGE_HEADING: {
    HEAD: 'Teams',
  },

  TEAM_LIST_COLUMNS: [
    {
      title: '',
      key: 'name',
    },
    {
      title: 'Name',
      key: 'name',
    },
    {
      title: 'Owner',
      key: 'owner',
    },
    {
      title: 'Team Members',
      key: 'team_members',
    },
  ],
  TEAM_DETAIL_LIST_TAB: [
    {
      label: 'DETAILS',
      key: 'details',
    },
    {
      label: 'TEAM MEMBERS ',
      key: 'team_members',
    },
  ],

  CSV_DATA_SAMPLE_DATA: [
    ['Name', 'Description'],
    ['Team1', 'This is Team1 description'],
    ['Team2', 'This is Team2 description'],
    ['Team3', 'This is Team3 description'],
    ['Team4', 'This is Team4 description'],
    ['Team5', 'This is Team5 description'],
    ['Team6', 'This is Team6 description'],
    ['Team7', 'This is Team7 description'],
    ['Team8', 'This is Team8 description'],
  ],

  CSV_TEAM_MEMBER_SAMPLE_DATA: [
    ['Name', 'Email', 'Role'],
    ['Laura', 'laura@example.com', 'NORMAL'],
    ['Craig', 'craig@example.com', 'PRIMARY'],
    ['Mary', 'mary@example.com', 'PRIMARY'],
    ['Jamie', 'jamie@example.com', 'NORMAL'],
  ],

  UPLOAD_TEAM_COL: ['Name', 'Description'],
  UPLOAD_TEAM_MEMBERS_COL: ['Name', 'Email', 'Role'],

  TEAM_DETAIL_LIST_COLUMNS: {
    NAME: 'Name',
    EMAIL: 'Email',
    ROLEACTION: 'Role/Action',
  },
  TEAM_PAGE_TYPE: {
    CREATE_TEAM_PAGE: 'create',
    UPDATE_TEAM_PAGE: 'update',
  },
  TEAM_MEMBER_ACTIONS: {
    MARK_AS_PRIMARY: 'Mark As Primary',
    MARK_AS_NORMAL: 'Mark As Normal',
    NORMAL_ROLE: 'Normal',
    PRIMARY_ROLE: 'Primary',
    NORMAL_ROLE_KEY: 'NORMAL',
    PRIMARY_ROLE_KEY: 'PRIMARY',
  },

  TEAM_MEMBER_UPLOAD_MESSAGE: {
    SUCCESS: 'Added',
    FAILED: 'Failed',
  },
  TEAM_LIST_UPLOAD_MESSAGE: {
    SUCCESS: 'Created',
    FAILED: 'Failed',
  },

  TEAM_MEMBER_ACTION_PRIMARY: [
    {
      key: '1',
      label: 'Mark As Primary',
    },
    {
      key: '2',
      label: 'Remove',
    },
  ],

  TEAM_MEMBER_ACTION_NORMAL: [
    {
      key: '1',
      label: 'Mark As Normal',
    },
    {
      key: '2',
      label: 'Remove',
    },
  ],

  TEAM_OWNER_ACTION: [
    {
      items: [
        {
          key: '3',
          label: 'Transfer Ownership',
        },
      ],
    },
  ],

  TEAM_DETAIL_FORM: {
    NAME: 'name',
    NAME_LABEL: 'Name',
    NAME_PLACEHOLDER: 'Team Name',

    DESCRIPTION: 'description',
    DESCRIPTION_LABEL: 'Description',
    DESCRIPTION_PLACEHOLDER: 'Enter Description here...',
  },

  TEAM_DETAIL_BUTTONS: {
    ADD_MEMBERS: 'Add Members',
    SUBMIT_TEAM: 'Add',
    SAVE_TEAM: 'Save',
    EDIT_TEAM: 'EDIT',
  },

  TEAM_DETAIL_PLACEHOLDERS: {
    SEARCH_BY_NAME: 'Search By Name',

    SELECT_MEMBERS: 'Please select',
    SELECT_MEMBERS_SEARCH: 'Search By Name or Email Id',
  },

  TEAM_DETAIL_MODAL_VALUE: {
    ADD_MEMBER_MODAL_TITLE: 'Add Members To Team',
    ADD_MEMBER_MODAL_SUB_TITLE: 'adding team members.',
  },

  TEAM_LIST_NO_DATA: {
    type: 'NO_TEAMS',
    messageTeamList: 'You do not have any Teams to display!',
    messageMemberList: 'No Members added',
  },

  TEAM_MODAL_MESSAGE: {
    CREATE_TEAM: {
      TITLE: 'SUCCESS',
      MESSAGE: 'Created Successfully',
    },
    UPDATE_TEAM: {
      TITLE: 'SUCCESS',
      MESSAGE: 'Updated Successfully!',
    },

    ADD_MEMBERS: {
      TITLE: 'SUCCESS',
      MESSAGE: 'Added Successfully!',
    },

    REMOVE_MEMBERS: {
      TITLE: 'SUCCESS',
      MESSAGE: 'Removed Successfully!',
    },

    REMOVE_MEMBER: {
      TITLE: 'ARE YOU SURE?',
      MESSAGE: 'You want to remove this team member.',
    },
    TRANSFER_TEAM_OWNERSHIP: {
      TITLE: 'SUCCESS',
      MESSAGE: 'Team Ownership Changed Successfully!',
    },
  },
};

const buttonText = {
  CLEAR: 'CLEAR',
  SAVE: 'Save',
  DONE: 'Done',
  VIEW: 'View',
};

/* The `accountsConstant` object is defining constants related to the Accounts Component
functionality. It includes the following properties: */
const accountsConstant = {
  ACCOUNTS_HEADER: {
    ACCOUNTS_HEADING: 'Accounts',
    MY_INVITEES_HEADEING: 'My Invitees',
    VIEW_INVITEES_TEXT: 'VIEW MY INVITEES',
    VIEW_ACCOUNTS_TEXT: 'VIEW ALL ACOUNTS',
    STATUS: 'STATUS',
    LOCATION: 'LOCATION',
    INVITE_BUTTON: 'INVITE',
    SEARCH_PLACEHOLDER: 'Search by Name/Email/Mobile Number',
  },
  STATUS_DROPDOWN_MENU: {
    TAB_KEY: 'Status',
    ALL: 'All',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    NEW: 'New',
  },
  LOCATION_DROPDOWN_MENU: {
    TAB_KEY: 'Location',
    ALL: 'All',
    ACTIVE: 'Shared',
    INACTIVE: 'Not Shared',
  },
  CARD_VIEW: {
    GRID_VIEW: 'GRID',
    MAP_VIEW: 'MAP',
    LIST_VIEW: 'LIST',
  },
  ROLE_TYPE: {
    OWNER: 'OWNER',
    ADMIN: 'ADMIN',
    NORMAL: 'NORMAL',
  },
  STATUS_TYPE: {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    NEW: 'NEW',
  },
  RESEND_INVITATION_MODAL: {
    TITLE: 'SUCCESS',
    CONTENT: 'Invitation Resent Successfully!',
  },
  SEND_INVITE_MODAL: {
    NAME: {
      LABEL: 'Name',
      PLACEHOLDER: 'Enter name here..',
      MESSAGE: 'Name is required!',
    },
    EMAIL: {
      LABEL: 'Email',
      PLACEHOLDER: 'Enter Email here..',
      TYPE: 'email',
      MESSAGE: 'Invalid Email!',
    },
    COUNTRY: {
      LABEL: 'Country',
      PLACEHOLDER: 'Select a country..',
    },
    MOBILE_NUMBER: {
      LABEL: 'Mobile Number',
      PLACEHOLDER: 'Enter mobile here..',
      MESSAGE: 'Mobile number is required!',
      regexPattern: /^\d+$/,
      INVALID_MESSAGE: 'Not a valid mobile number!',
    },
    ROLE: {
      LABEL: 'Role',
      MESSAGE: 'Role is required!',
      ROLE_OWNER: 'OWNER',
      ROLE_ADMIN: 'ADMIN',
      ROLE_NORMAL: 'NORMAL',
    },
    SEND_INVITE_BUTTON: 'SEND INVITE',
    SUCCESS_TITLE: 'SUCCESS',
    SUCCESS_CONTENT: 'Invitation Sent Successfully!',
    WARNING_TITLE: 'Warning',
    WARNING_CONTENT: 'Account already exist with this emailId.',
  },
  List_CARD_VIEW: {
    PICTURE: 'Picture',
    NAME: 'Name',
    EMAIL: 'Email',
    MOBILE_NUMBER: 'Mobile Number',
    STATUS: 'Status',
    ROLE: 'Role',
    LAST_LOGGED_ON: 'Last Logged On',
  },
  ACCOUNT_DETAILS_HEADER: {
    PROFILE: 'Business Profile',
    LOG_STATUS: 'Last Logged on (Web)',
    MOBILE_LOG_STATUS: 'Last Logged on (Mobile)',
    LOCATION_STATUS: 'Location Sharing',
    LOCATION_STATUS_VIEW: 'view',
    SAVE_BUTTON: 'SAVE',
  },
  UPDATE_USER_DETAILS: {
    USER_DETAILS_FORM: {
      NAME: {
        LABEL: 'Name',
        PLACEHOLDER: 'Enter name here..',
      },
      EMAIL: {
        LABEL: 'Email',
        PLACEHOLDER: 'Enter your email..',
      },
      COUNTRY: {
        LABEL: 'Country',
        PLACEHOLDER: 'Select a country..',
      },
      MOBILE_NUMBER: {
        LABEL: 'Mobile Number',
        PLACEHOLDER: 'Enter mobile here..',
      },
      LANGUAGE: {
        LABEL: 'Preferred Language',
        PLACEHOLDER: 'Select a language..',
        OPTIONS: {
          ENGLISH: 'English',
          HINDI: 'Hindi',
          TELUGU: 'Telugu',
        },
      },
    },
    NO_SERVICES_MESSAGE: 'No active services to display!',
    NO_ACTIVITIES_MESSAGE: 'No activities to display!',
    TITLE: 'SUCCESS',
    CONTENT: 'Updated Successfully!',
  },
  USER_ACCOUNT_ROLE_TYPE: {
    OWNER: 'Owner',
    ADMIN: 'Admin',
    NORMAL: 'Normal',
    SUCCESS_MESSAGE: 'UPDATED SUCCESSFULLY',
    USER_PERMISSION_ERROR_MESSAGE: "You don't have access to perform this action",
    USER_ROLE_ERROR_MESSAGE: "You can't change your own role",
  },
  USER_STATUS_MODAL: {
    ACTIVE: {
      TITLE: 'ARE YOU SURE?',
      CONTENT: "You want to 'ACTIVE' this account.",
    },
    INACTIVE: {
      TITLE: 'ARE YOU SURE?',
      CONTENT: "You want to 'INACTIVE' this account.",
    },
  },
  MESSAGE_POPUP: {
    SUCCESS: {
      CLASSNAME: 'success-message',
      TYPE: 'success',
    },
    ERROR: {
      CLASSNAME: 'error-message',
      TYPE: 'error',
    },
    WARNING: {
      CLASSNAME: 'warning-message',
      TYPE: 'warning',
    },
    INFO: {
      CLASSNAME: 'info-message',
      TYPE: 'info',
    },
  },
  UPLOAD_ACCOUNTS_COL: ['Name', 'Email', 'Role'],

  ACCOUNTS_CSV_DATA_SAMPLE_DATA: [
    ['Name', 'Email', 'Role'],
    ['Laura', 'laura@example.com', 'NORMAL'],
    ['Craig', 'craig@example.com', 'ADMIN'],
    ['Mary', 'mary@example.com', 'OWNER'],
    ['Jamie', 'jamie@example.com', 'NORMAL'],
  ],

  ACCOUNTS_INVITE_LIST_UPLOAD_MESSAGE: {
    SUCCESS: 'Invitation Sent',
    FAILED: 'Failed',
  },
  USER_LOCATION_MOADL_HEADING: 'Location Inactive',
  INFO_WINDOW_LOCATION_STATUS_TEXT: 'Last Shared Location',
};

const reportConstant = {
  NEW_REPORT_FORM: {
    TITLE: {
      NAME: 'label',
      PLACEHOLDER: 'Enter Report Title',
      REQUIRED_MESSAGE: 'Title field cannot be empty !',
    },
    FILTER_BY_TYPE: {
      NAME: 'filterBy',
      REQUIRED_MESSAGE: 'Please Select Filter by !',
    },
    FILTER_BY_DATE: {
      REQUIRED_MESSAGE: 'Filter by date is required !',
      PLACEHOLDER: 'Choose...',
    },
    FROM_DATE: {
      REQUIRED_MESSAGE: 'Please Select from date !',
    },
    TO_DATE: {
      REQUIRED_MESSAGE: 'Please Select to date !',
    },
    SORT_ON: {
      REQUIRED_MESSAGE: 'Please Select Sort By !',
    },
    SORT_BY: {
      REQUIRED_MESSAGE: 'Sort is required !',
      PLACEHOLDER: 'Choose...',
    },
    OUTPUT_FORMATE: {
      REQUIRED_MESSAGE: 'Please select file format!',
    },
  },

  POPOVER: {
    MODAL: {
      ALL_RADIO: {
        LINE_1: 'If criteria is given in report settings,Only transactions',
        LINE_2: 'in report settings,',
        LINE_3: 'Only transactions',
        LINE_4: 'matched with',
        LINE_5: 'report criteria',
        LINE_6: 'will be giver',
        LINE_7: 'in report',
      },
      PDF: {
        LINE_1: 'Please ensure that the Report view has no more than 6 columns.',
        LINE_2: 'If there are more than 6 columns, the PDF feature is Disabled.',
        LINE_3: 'To enable the PDF feature, please navigate to the report settings and update the view as needed.',
      },
    },
  },
};
const form = {
  DYNAMIC_FORM: {
    MANDATORY: 'Please fill',
    PLEASE_ENTER: 'Please enter at least',
    CHARACTERS: 'character(s)',
    SHOULD_NOT: 'Should not exceed',
    PLEASE_PROVIDE: 'Please provide at least',
    DIGITS: 'digit(s)',
    EMAIL_VALIDATION_MSG: 'Not an email! ex.. xyz@domain.com',
    SEND_EMAIL: 'Send Email',
    OPTIONS_NOT_AVAILABLE: 'Options Not Available',
    VALID_MOBILE: 'Please enter valid mobile number',
    NO_QR_CODE_TEXT: 'No QR Code available',
    NO_BAR_CODE_TEXT: 'No Bar Code available',
    TABLE_ROW: 'Please add atleast one row for',
    TABLE_MANDATORY: 'Please fill the',
    VALID_MOBILE_NUMBER: 'Please enter valid',
  },
  EMPTY_IMAGE:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAjgAAADcCAQAAADXNhPAAAACIklEQVR42u3UIQEAAAzDsM+/6UsYG0okFDQHMBIJAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHADDAQwHMBwAwwEMB8BwAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEwHMBwAMMBMBzAcAAMBzAcwHAADAcwHADDAQwHMBwAwwEMB8BwAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcCQADAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHMBwAAwHMBwAwwEMBzAcAMMBDAfAcADDAQwHwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHMBwAAwHMBwAwwEMB8BwAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDkQAwHMBwAAwHMBwAwwEMBzAcAMMBDAfAcADDAQwHwHAAwwEwHMBwAMMBMBzAcAAMBzAcwHAADAcwHADDAQwHMBwAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHMBwAAwHMBwAwwEMBzAcAMMBDAegeayZAN3dLgwnAAAAAElFTkSuQmCC',
};

const templates = {
  UI_TEMPLATES: {
    EDIT_TEXT_UI_TEMPLATE: 'editTextUiTemplate',
    MOBILE_NUMBER_UI_TEMPLATE: 'mobileNumberUiTemplate',
    NUMBER_UI_TEMPLATE: 'numberUiTemplate',
    EMAIL_TEXT_UI_TEMPLATE: 'emailTextUiTemplate',
    CHECKBOX_UI_TEMPLATE: 'checkBoxUiTemplate',
    RADIO_BUTTON_UI_TEMPLATE: 'radioButtonUiTemplate',
    SINGLE_CHOICE_UI_TEMPLATE: 'singleChoiceUiTemplate',
    TEXTAREA_UI_TEMPLATE: 'textAreaUiTemplate',
    DATE_PICKER_UI_TEMPLATE: 'datePickerUiTemplate',
    MULTI_SELECT_UI_TEMPLATE: 'multiSelectUiTemplate',
    LOCATION_UI_TEMPLATE: 'locationUiTemplate',
    LOOKUP_UI_TEMPLATE: 'lookupUiTemplate',
    RATING_UI_TEMPLATE: 'starRatingUiTemplate',
    SIGNATURE_UI_TEMPLATE: 'signatureUiTemplate',
    FILE_UPLOAD_UI_TEMPLATE: 'fileUploadUiTemplate',
    CURRENCY_UI_TEMPLATE: 'currencyUiTemplate',
    IMAGE_UPLOAD_UI_TEMPLATE: 'imageUploadUiTemplate',
    SECTION_UI_TEMPLATE: 'sectionUiTemplate',
    QR_CODE_UI_TEMPLATE: 'qrCodeUiTemplate',
    BAR_CODE_UI_TEMPLATE: 'barCodeUiTemplate',
    FORMULA_UI_TEMPLATE: 'formulaUiTemplate',
    URL_UI_TEMPLATE: 'urlUiTemplate',
    TABLE_UI_TEMPLATE: 'tableUiTemplate',
    SUB_FORM_UI_TEMPLATE: 'subFormUiTemplate',
    AUTO_NUMBER_UI_TEMPLATE: 'autoNumberUiTemplate',
    SPACER_UI_TEMPLATE: 'spacerUiTemplate',
    LINE_UI_TEMPLATE: 'lineUiTemplate',
    WIDGET_UI_TEMPLATE: 'widgetUiTemplate',
    GRAPH_UI_TEMPLATE: 'graphUiTemplate',
    BUTTON_UI_TEMPLATE: 'buttonUiTemplate',
    DOCUMENT_VIEW_TEMPLATE: 'documentViewUiTemplate',
    DOCUMENT_ANALYSIS_UI_TEMPLATE: 'documentAnalysisUiTemplate',
    ENCRYPT_UI_TEMPLATE: 'encryptUiTemplate'
  },
};
const activityConstant = {
  ACTIVITY_SEARCH_PLACEHOLDER: 'Search by Name',
  ACTIVITY_PLATFORM_TYPES: {
    USR_STAFF: 'USR_STAFF',
    USR_INDIVIDUAL: 'USR_INDIVIDUAL',
    USR_GROUP: 'USR_GROUP',
    TXN_BOOKING: 'TXN_BOOKING',
    TXN_BUYING: 'TXN_BUYING',
    TXN_FORM: 'TXN_FORM',
    TASK: 'TASK',
    PRODUCT: 'PRODUCT',
    RESOURCE: 'RESOURCE',
    INVITATION: 'INVITATION',
    BUSINESS_TEAM: 'BUSINESS_TEAM',
    USER_STATE_CHANGE: 'USER_STATE',
    PPT_ACCESS: 'PPT_ACCESS',
    DATA_FLOW: 'DATA_FLOW',
    SERVICE: 'SERVICE',
    BUSINESS_ACCOUNT: 'BUSINESS_ACCOUNT',
    TABLE: 'TABLE',
    SUB_FORM: 'SUBFORM',
    CLIENT_REGISTRY: 'CLIENT_REGISTRY',
  },
  ICONS: {
    ICON_STAFF: 'img/No-data-messages/No-Accounts.png',
    ICON_CUSTOMERS: 'img/No-data-messages/No-Accounts.png',
    ICON_GROUP: 'img/No-data-messages/No-Teams.png',
    ICON_PAYMENTS: 'img/No-data-messages/No-Payments.png',
    ICON_TIME_RESOURCE: 'img/settings/hoo_resources.png',
    ICON_STATIC_RESOURCE: 'img/settings/hoo_resources.png',
    ICON_BOOKINGS: 'img/settings/hoo_bookings.png',
    ICON_RULES: 'img/settings/hoo_rules.png',
    ICON_ROLES: 'img/settings/hoo_permissions.png',
    ICON_RATE_PLANS: 'img/No-data-messages/No-Perspectives.png',
    ICON_REPORTS: 'img/No-data-messages/No-Reports.png',
    ICON_PRODUCTS: 'img/settings/hoo_products.png',
    ICON_BUYING: 'img/settings/hoo_buying.png',
    ICON_SERVICES: 'img/No-data-messages/No-Services.png',
    ICON_CONSUMER_API_DOCUMENT: 'img/No-data-messages/No-Forms.png',
    ICON_FORMS: 'img/No-data-messages/No-Forms.png',
    ICON_MEMBERSHIP: 'img/settings/hoo_loyalty.png',
    ICON_CUSTOM_FUNCTION: 'img/settings/hoo_custom_function.png',
    ICON_NOTIFICATION_TEMPLATES: 'img/No-data-messages/No-Notifications.png',
    ICON_DASHBOARD: 'img/No-data-messages/No-Dashboard.png',
    ICON_EVENTS: 'img/No-data-messages/No-Events.png',
    ICON_TABLE: 'img/settings/tables.png',
    ICON_SUB_FORM: 'img/No-data-messages/No-Forms.png',
    ICON_CLIENT_REGISTRY: 'img/No-data-messages/No-Forms.png',
    ICON_REST_TOKENS: 'img/No-data-messages/No-REST-APIs.png',
    TASK_ICON: 'img/No-data-messages/No-Consumers-1.png',
    ICON_INVITATION_SENT: 'img/No-data-messages/No-Inviations.png',
    ICON_BUSINESS_TEAM: 'img/No-data-messages/No-Teams.png',
    ICON_USER_STATE_CHANGE: 'img/No-data-messages/No-Accounts.png',
    ICON_CONNECTORS: 'img/No-data-messages/No-Rules.png',
  },
};

/** The `dashboardConstant` object is defining constants related to dashboard functionality.
Each object in the array has two properties: `title` and `key`. */
const dashboardConstant = {
  DASHBOARD_PAGE_HEADING: {
    MY_DASHBOARD: 'My Dashboard',
    MY_CALENDAR: 'My Calendar',
    My_APPS: 'My Apps',
  },
  CALENDAR: {
    TITLE: 'My Calendar',
  },
  APPS: {
    BUTTON: 'View All',
    TRENDING: 'Trending',
  },
  MY_DASHBOARD: {
    DROPDOWN: [
      {
        key: 'Created Date',
        label: 'Created Date',
      },
      {
        key: 'Last Modified',
        label: 'Last Modified',
      },
      {
        key: 'Date of birth',
        label: 'Date of birth',
      },
    ],
    FILTERS: [
      {
        key: 'YESTERDAY',
        label: 'Yesterday',
      },
      {
        key: 'DAY',
        label: 'Today',
      },
      {
        key: 'TOMORROW',
        label: 'Tomorrow',
      },
      {
        key: 'WEEK',
        label: 'Week',
      },
      {
        key: 'MONTH',
        label: 'Month',
      },
      {
        key: 'YEAR',
        label: 'Year',
      },
      {
        key: 'LAST_YEAR',
        label: 'Last 12 Months',
      },
      {
        key: 'CUSTOM_RNAGE',
        label: 'Custom Range',
      },
    ],
  },
  FAVOURITE_DASH: {
    title: 'Add to Favourites',
    subtitle: 'Select to show on Home Dashboard',
    sucessmsg: 'Dashboard added to your Home Favourites!',
    draggedmsg: 'Done! Dashboard has been updated successfully!',
  },
};

/** The `appPageConstant` object is defining constants related to dashboard functionality.
Each object in the array has two properties: `title` and `key`. */
const appPageConstant = {
  SEARCH: {
    PLACEHOLDER: 'Search by Name',
  },
  BUTTON: {
    ADD_NEW: 'Add New',
  },
  SEARCH_APPS: 'Search Apps'
};


/** The `mapConstant` object is defining constants related to map wrapper functionality.
Each object in the array has two properties: `title` and `key`. */
const mapConstant = {
  SEARCH: {
    PLACEHOLDER: 'Search Location',
  },
  GOOGLE_MAPS_URL: {
    SEARCH: 'https://maps.googleapis.com/maps/api/place/autocomplete/json',
    SELECT: 'https://maps.googleapis.com/maps/api/place/details/json',
  },
};

const flowsConstant = {
  componentType: {
    FLOW: 'FLOW',
  },
  flowsType: {
    BUSINESS_FLOWS: 'Business Flows',
    CONNECTORS: 'Connectors',
    PROCESSORS_BOTS: 'Processors and Bots',
  },
  VIEW_MORE_CARD: {
    VIEW: 'VIEW',
    MORE: 'MORE',
  },
};

const comments = {
  REQUIRED: 'Please enter a comment.',
  DELETED: 'Comment Deleted Successfully!',
  UPDATED: 'Comment Updated Successfully!',
  ADDED: 'Comment Added Successfully!',
};

const googleMapApiKey = {
  // GOOGLE_MAPS_API_KEY: 'AIzaSyAzm8zjbZPzNVjEdE3s1RaNdSN5XffL0BA',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAoAcynRDV7x90Scf36_ReF6ufCOHyJOzs',
};

const lookup = {
  SEARCH: 'type 2 characters to search',
  NO_DATA_MESSAGE: 'No Result(s) Found',
  TYPE: 'NO_USERS',
};

const transactionConstant = {
  filter: [
    {
      label: 'Date',
      type: 'datePickerUiTemplate',
      isSkippable: false,
      isSystem: true,
      value: '',
      columnWidth: 'col-6 col-sm-6',
      placeholderText: 'Date',
      colorVal: '#000000',
      isBold: false,
      isItalic: false,
      fontSize: 15,
      refId: '60d170e8a2bcf249ab8a6096',
      name: 'Date',
    },
    {
      label: 'Single Selection',
      type: 'singleChoiceUiTemplate',
      isSkippable: true,
      isSystem: true,
      value: '',
      columnWidth: 'col-6 col-sm-6',
      placeholderText: 'Single Selection',
      options: ['choice1', 'choice2', 'Choice3'],
      defaultValue: -1,
      isStatusField: false,
      enableComment: true,
      enableAttachment: true,
      name: 'Single_Selection',
      refId: '60d170e8a2bcf249ab8a6097',
      colorCodes: ['#F44336', '#4CAF50', '#3F51B5'],
      notShowFieldValues: false,
    },
    {
      label: 'Radio Button',
      type: 'radioButtonUiTemplate',
      isSkippable: true,
      isSystem: true,
      value: '',
      columnWidth: 'col-6 col-sm-6',
      placeholderText: 'Radio Button',
      options: ['radio1', 'radio2', 'radio3'],
      defaultValue: -1,
      isStatusField: false,
      enableComment: false,
      enableAttachment: false,
      refId: '60d170e8a2bcf249ab8a6098',
      name: 'Radio_Button',
    },
    {
      label: 'Look Up',
      type: 'lookupUiTemplate',
      isSkippable: true,
      isSystem: true,
      value: '',
      columnWidth: 'col-6 col-sm-6',
      placeholderText: 'Look Up',
      lookupType: 'SVC_TYPE_87',
      displayType: 'singleChoiceUiTemplate',
      displayFields: ['fields.Text', 'fields.Mobile_Number', 'createdOn'],
      enableCreate: false,
      dependsOn: [
        {
          cFid: '60d170e8a2bcf249ab8a6097',
          pFid: '6211d164a2bcf25f1a541520',
          operator: '==',
        },
      ],
      criteria: [],
      name: 'Look_Up',
      rList: {
        label: 'Related List',
        fields: ['txnId', 'createdOn'],
      },
      enableFixedView: true,
      enablePerspectiveView: false,
      refId: '60f98743a2bcf2588917eab9',
    },
    {
      label: 'Multi Selection',
      type: 'multiSelectUiTemplate',
      isSkippable: true,
      isSystem: true,
      value: [],
      columnWidth: 'col-6 col-sm-6',
      placeholderText: 'Multi Selection',
      options: ['choice1', 'choice2', 'choice3'],
      defaultValue: -1,
      name: 'Multi_Selection',
      refId: '6128b307a2bcf23dbb4b9d64',
    },
    {
      name: '_Created_Date',
      label: 'Created Date',
      type: 'datePickerUiTemplate',
      key: 'createdOn',
      templateKey: '$dateTimeUtil.formatMillisToDateString( $transaction.createdOn , "MMM dd, yyyy")',
    },
    {
      name: '_Last_Modified',
      label: 'Last Modified',
      type: 'datePickerUiTemplate',
      key: 'modifiedOn',
      templateKey: '$dateTimeUtil.formatMillisToDateString( $transaction.modifiedOn , "MMM dd, yyyy")',
    },
    {
      name: '_Status',
      label: 'Status',
      type: 'singleChoiceUiTemplate',
      options: ['ACTIVE', 'INACTIVE'],
      key: 'state',
    },
    {
      name: '_Txn_Owner',
      label: 'Transaction Owner',
      type: 'singleChoiceUiTemplate',
      key: 'owner.email',
      templateKey: '$transaction.owner.email',
    },
    {
      name: '_Created_By',
      label: 'Created By',
      type: 'singleChoiceUiTemplate',
      key: 'createdBy',
      templateKey: '$transaction.createdBy',
    },
  ],

  FILTER_OPERATOR_LIST: [
    {
      value: 'EQUALS',
      label: 'EQUALS(=)',
    },
    {
      value: 'NE',
      label: 'NOT EQUALS(!=)',
    },
    {
      value: 'GT',
      label: 'GREATER THAN(>)',
    },
    {
      value: 'LT',
      label: 'LESS THAN(<)',
    },
    {
      value: 'GTE',
      label: 'GREATER THAN OR EQUAL(>=)',
    },
    {
      value: 'LTE',
      label: 'LESS THAN OR EQUAL(<=)',
    },
  ],

  CRITERIA_LIST: [
    { key: 'Currency', label: 'Currency' },
    { key: 'Number', label: 'Number' },
  ],

  MAP_ICON: {
    Map: 'M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z',
    Person:
      'M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z',
    Pin: 'M320 144C320 223.5 255.5 288 176 288C96.47 288 32 223.5 32 144C32 64.47 96.47 0 176 0C255.5 0 320 64.47 320 144zM192 64C192 55.16 184.8 48 176 48C122.1 48 80 90.98 80 144C80 152.8 87.16 160 96 160C104.8 160 112 152.8 112 144C112 108.7 140.7 80 176 80C184.8 80 192 72.84 192 64zM144 480V317.1C154.4 319 165.1 319.1 176 319.1C186.9 319.1 197.6 319 208 317.1V480C208 497.7 193.7 512 176 512C158.3 512 144 497.7 144 480z',
    House:
      'M575.8 255.5C575.8 273.5 560.8 287.6 543.8 287.6H511.8L512.5 447.7C512.5 450.5 512.3 453.1 512 455.8V472C512 494.1 494.1 512 472 512H456C454.9 512 453.8 511.1 452.7 511.9C451.3 511.1 449.9 512 448.5 512H392C369.9 512 352 494.1 352 472V384C352 366.3 337.7 352 320 352H256C238.3 352 224 366.3 224 384V472C224 494.1 206.1 512 184 512H128.1C126.6 512 125.1 511.9 123.6 511.8C122.4 511.9 121.2 512 120 512H104C81.91 512 64 494.1 64 472V360C64 359.1 64.03 358.1 64.09 357.2V287.6H32.05C14.02 287.6 0 273.5 0 255.5C0 246.5 3.004 238.5 10.01 231.5L266.4 8.016C273.4 1.002 281.4 0 288.4 0C295.4 0 303.4 2.004 309.5 7.014L564.8 231.5C572.8 238.5 576.9 246.5 575.8 255.5L575.8 255.5z',
    Work: 'M320 336c0 8.844-7.156 16-16 16h-96C199.2 352 192 344.8 192 336V288H0v144C0 457.6 22.41 480 48 480h416c25.59 0 48-22.41 48-48V288h-192V336zM464 96H384V48C384 22.41 361.6 0 336 0h-160C150.4 0 128 22.41 128 48V96H48C22.41 96 0 118.4 0 144V256h512V144C512 118.4 489.6 96 464 96zM336 96h-160V48h160V96z',
    Bike: 'M342.5 32C357.2 32 370.7 40.05 377.6 52.98L391.7 78.93L439.1 39.42C444.9 34.62 452.1 32 459.6 32H480C497.7 32 512 46.33 512 64V96C512 113.7 497.7 128 480 128H418.2L473.3 229.1C485.5 226.1 498.5 224 512 224C582.7 224 640 281.3 640 352C640 422.7 582.7 480 512 480C441.3 480 384 422.7 384 352C384 311.1 402.4 276.3 431.1 252.8L415.7 224.2C376.1 253.4 352 299.8 352 352C352 362.1 353.1 373.7 355.2 384H284.8C286.9 373.7 287.1 362.1 287.1 352C287.1 263.6 216.4 192 127.1 192H31.1V160C31.1 142.3 46.33 128 63.1 128H165.5C182.5 128 198.7 134.7 210.7 146.7L255.1 192L354.1 110.3L337.7 80H279.1C266.7 80 255.1 69.25 255.1 56C255.1 42.75 266.7 32 279.1 32L342.5 32zM448 352C448 387.3 476.7 416 512 416C547.3 416 576 387.3 576 352C576 316.7 547.3 288 512 288C509.6 288 507.2 288.1 504.9 288.4L533.1 340.6C539.4 352.2 535.1 366.8 523.4 373.1C511.8 379.4 497.2 375.1 490.9 363.4L462.7 311.2C453.5 322.3 448 336.5 448 352V352zM253.8 376C242.5 435.2 190.5 480 128 480C57.31 480 0 422.7 0 352C0 281.3 57.31 224 128 224C190.5 224 242.5 268.8 253.8 328H187.3C177.9 304.5 154.9 288 128 288C92.65 288 64 316.7 64 352C64 387.3 92.65 416 128 416C154.9 416 177.9 399.5 187.3 376H253.8zM96 352C96 334.3 110.3 320 128 320C145.7 320 160 334.3 160 352C160 369.7 145.7 384 128 384C110.3 384 96 369.7 96 352z',
    Store:
      'M495.5 223.2C491.6 223.7 487.6 224 483.4 224C457.4 224 434.2 212.6 418.3 195C402.4 212.6 379.2 224 353.1 224C327 224 303.8 212.6 287.9 195C272 212.6 248.9 224 222.7 224C196.7 224 173.5 212.6 157.6 195C141.7 212.6 118.5 224 92.36 224C88.3 224 84.21 223.7 80.24 223.2C24.92 215.8-1.255 150.6 28.33 103.8L85.66 13.13C90.76 4.979 99.87 0 109.6 0H466.4C476.1 0 485.2 4.978 490.3 13.13L547.6 103.8C577.3 150.7 551 215.8 495.5 223.2H495.5zM499.7 254.9C503.1 254.4 508 253.6 512 252.6V448C512 483.3 483.3 512 448 512H128C92.66 512 64 483.3 64 448V252.6C67.87 253.6 71.86 254.4 75.97 254.9L76.09 254.9C81.35 255.6 86.83 256 92.36 256C104.8 256 116.8 254.1 128 250.6V384H448V250.7C459.2 254.1 471.1 256 483.4 256C489 256 494.4 255.6 499.7 254.9L499.7 254.9z',
  },
  MODE_LIST: ['list', 'catalog', 'table', 'location', 'calendar'],

  COMMENT_MODAL: {
    NeedHelp: 'NEED HELP?',
    SELECT_A_COMMENT: 'SELECT A COMMENT',
  },
};

const googleMapBaseUrl = {
  GOOGLE_MAPS_BASE_URL: 'https://maps.googleapis.com/maps/api/geocode/json',
};

const appsSettingsConstant = {
  APP_SVC_TYPE: 'SVC_TYPE_116',
  APP_STATUS: 'ACTIVE',
  ENABLED_TYPE: 'ACCOUNT',
  APPS_SETTINGS_SCREENTYPE: {
    IMPORT_CSV: 'IMPORT_DATA',
    ADD_USER: 'ADD_USER',
    SELECT_ADD_USER_PERSECTIVE: 'SELECT_ADD_USER_PERSECTIVE',
    REMOVE_USER: 'REMOVE_USER',
    SELECT_REMOVE_USER_PERSECTIVE: 'SELECT_REMOVE_USER_PERSECTIVE',
    ADD_PERSECTIVE: 'ADD_PERSECTIVE',
    SELECT_PERSECTIVE_USER: 'SELECT_PERSECTIVE_USER',
    REMOVE_PERSECTIVE: 'REMOVE_PERSECTIVE',
    SELECT_REMOVE_PERSPECTIVE_USER: 'SELECT_REMOVE_PERSPECTIVE_USER',
  },
  MENU_ITEMS: {
    USER: 'USER',
    USER_MENU_LIST: {
      ADD: 'Add',
      REMOVE: 'Remove',
    },
    IMPORT_CSV: 'Import Data',
    PERSPECTIVE: 'PERSPECTIVE',
    PERSPECTIVE_MENU_ITEM: {
      ADD_USER: 'Add User',
      REMOVE_USER: 'Remove User',
    },
    NOTIFY: 'Notify',
    NOTIFY_MENU_ITEM: {
      MY_TRANSACTIONS: 'Activity on My Transactions',
      NEW_TRANSACTIONS: 'New Transactions',
      ALL_TRANSACTIONS: 'Activity on All Transactions',
    },
    ACTIVITY: 'Activity',
    SETTINGS: 'Settings',
  },
  NOTIFICATIONS_MESSAGE_TYPE: {
    TOGGLE_ON: 'enabled',
    TOGGLE_OFF: 'disabled',
    MY_TRANSACTIONS: 'myTransactions',
    NEW_TRANSACTIONS: 'newTransactions',
    ALL_TRANSACTIONS: 'allTransactions',
  },
  NOTIFICATIONS_MESSAGE: {
    TOGGLE_ON: 'Notifications for this service enabled successfully!!',
    TOGGLE_OFF: 'Notifications for this service disabled successfully!!',
    MY_TRANSACTIONS_ENABLED: 'Activity on My Transactions enabled successfully!!',
    MY_TRANSACTIONS_DISABLED: 'Activity on My Transactions disabled successfully!!',
    NEW_TRANSACTIONS_ENABLED: 'New Transactions enabled successfully!!',
    NEW_TRANSACTIONS_DISABLED: 'New Transactions disabled successfully!!',
    ALL_TRANSACTIONS_ENABLED: 'Activity on all Transactions enabled successfully!!',
    ALL_TRANSACTIONS_DISABLED: 'Activity on all Transactions disabled successfully!!',
  },
  ADD_USER_SUCCESS_MESSAGE: 'User Added Successfully!',
  REMOVE_USER_ERROR_MESSAGE: 'User Removed Successfully!',

  APPS_ACTIVITY: {
    HEADING: 'Activity',
    APP_NAME: '(Workflow Test)',
    ACTIVITY_LIST_HEADER: {
      DETAILS: 'Details',
      DATE: 'Date',
      TIME: 'Time',
    },
    NO_ACTIVITIES_MESSAGE: 'No active services to display!',
  },
  SELECT_USER_MODAL: {
    ADD_REMOVE_USER: {
      TITLE: 'Users',
      PLACEHOLDER: 'Search By Name',
    },
    ADD_REMOVE_USER_SELECT_PERSPECTIVE: {
      TITLE: 'Select Perspective',
      PLACEHOLDER: 'Search By Name',
      MODAL_TITLE: 'ARE YOU SURE?',
      ADD_MODAL_CONTENT: "You want to add this user(s) to the perspective 'Owner Access'.",
      DELETE_MODAL_CONTENT: "You want to delete this user(s) to the perspective 'Owner Access'.",
    },
    ADD_REMOVE_PERSPECTIVE: {
      TITLE: 'Perspectives',
      PLACEHOLDER: 'Search By Name',
    },
    ADD_REMOVE_PERSPECTIVE_SELECT_PERSPECTIVE: {
      TITLE: 'Select User',
      PLACEHOLDER: 'Search By Name',
      MODAL_TITLE: 'ARE YOU SURE?',
      ADD_MODAL_CONTENT: "You want to add this user(s) to the perspective 'Owner Access'.",
      DELETE_MODAL_CONTENT: "You want to delete this user(s) to the perspective 'Owner Access'.",
    },
    BUTTON: {
      NEXT: 'NEXT',
      DONE: 'DONE',
    },
  },
};

const notificationsConstant = {
  TITLE: 'NOTIFICATIONS',
  STATUS: {
    UNREAD: 'UNREAD',
    READ: 'READ',
    ARCHIVE: 'ARCHIVE',
  },
  SUCCESS_MESSAGE: {
    UNREAD: 'Notification READ Successfully!',
    READ: 'Notification UNREAD Successfully!',
    ARCHIVE: 'Notification DELETED Successfully!',
  },
};

const messageConstant = {
  SUCCESS: {
    CLASSNAME: 'success-message',
    TYPE: 'success',
  },
  ERROR: {
    CLASSNAME: 'error-message',
    TYPE: 'error',
  },
  WARNING: {
    CLASSNAME: 'warning-message',
    TYPE: 'warning',
  },
  INFO: {
    CLASSNAME: 'info-message',
    TYPE: 'info',
  },
};

const changeBusinessConstant = {
  CHANGE_BUSINESS_HEADING: 'Connected Business',
  CREATE_ANOTHER_BUSINESS_BUTTON: 'Ceate Another Business',
};

const businessProfileConstant = {
  BUSINESS_PROFILE_HEADING: 'Business Profile',
  CHANGE_PASSWORD_BUTTON: 'Change Password',
  LOGOUT_BUTTON: 'Logout',
  SAVE_BUTTON: 'SAVE',

  BUSINESS_PROFILE_FORM: {
    NAME: {
      LABEL: 'Name',
      PLACEHOLDER: 'Enter your Name',
    },
    EMAIL: {
      LABEL: 'Email Id',
      PLACEHOLDER: 'Enter your Email Id',
    },
    COUNTRY: {
      LABEL: 'Country',
      PLACEHOLDER: 'Select Country',
      OPTIONS: {
        INDIA: 'INDIA (+91)',
        US: 'USA (+1)',
      },
    },
    MOBILE_NUMBER: {
      LABEL: 'Mobile No.',
      PLACEHOLDER: 'Enter Mobile No.',
    },
    PREFERRED_LANGUAGE: {
      LABEL: 'Preferred Language',
      PLACEHOLDER: 'Select language',
      OPTIONS: {
        ENGLISH: 'English',
        HINDI: 'Hindi',
        TELUGU: 'Telugu',
      },
    },
  },
  NOTIFICATIONS: {
    HEADING: 'NOTIFICATIONS',
    NOTIFICATION_SUCCESS_MESSAGE: 'Notification changes are updated successfully!',
    PUSH_NOTIFICATIONS: {
      PUSH: 'Push Notifications',
      SMS: 'SMS',
      EMAIL: 'Email',
    },
    TRANSACTIONS: {
      HEADING: 'TRANSACTIONS',
      TYPE: {
        CREATE: 'Create',
        UPDATE: 'Update',
      },
    },
    USERS: {
      HEADING: 'USERS',
      TYPE: {
        CREATE: 'Create',
        UPDATE: 'Update',
      },
    },
    TASK: {
      HEADING: 'TASK',
      TYPE: {
        CREATE: 'Create',
        UPDATE: 'Update',
      },
    },
    SYSTEM_NOTIFICATION: {
      HEADING: 'System Notifications (Default)',
      TEAM: {
        HEADING: 'TEAM',
        TYPE: {
          ADD: 'Add',
          REMOVE: 'Remove',
          CHANGE_ROLE: 'Change Role',
          TRANSFER_ROLE: 'Transfer Owner',
        },
      },
      SERVICE_ACCESS: {
        HEADING: 'SERVICE ACCESS (PERSPECTIVES)',
        TYPE: {
          ADD: 'Add',
          REMOVE: 'Remove',
        },
      },
      BUSINESS_ROLE: {
        HEADING: 'BUSINESS ROLE',
        TYPE: {
          CHANGE_ROLE: 'Change Role',
        },
      },
    },
  },
  APPS: {
    TITLE: 'APPS',
    NO_APPS_TEXT: 'No active services to display!',
  },
  ACTIVITIES: {
    TITLE: 'ACTIVITIES',
    NO_ACTIVITY_TEXT: 'No activities to display!',
  },
  CHANGE_PASSWORD_MODAL_SCREEN: {
    EMAIL_VALIDATE: 'EMAIL_VALIDATE',
    OTP_VERIFICATION: 'OTP_VERIFICATION',
    CREATE_NEW_PASSWORD: 'CREATE_NEW_PASSWORD',
    EMAIL_TEXT: 'Would you like to change the password for',
    CREATE_NEW_PASSWORD_HEADING: 'Create New Password',
    CHANGE_PASSWORD_FORMAT_TEXT:
      'Password should contain atleast 8 characters with atleast 1 capital letter, 1 small letter, 1 number and 1 special character(., @, $, &, #, *).',
    NEW_PASSWORD_NAME: 'password',
    NEW_PASSWORD_PLACEHOLDER: 'New Password',
    CONFIRM_PASSWORD_NAME: 'confirm_password',
    CONFIRM_PASSWORD_PLACEHOLDER: 'Confirm Password',
    BUTTON: {
      CANCEL: 'Cancel',
      SEND_OTP: 'Send OTP',
      DONE: 'Done',
    },
  },
};

const txnForm = {
  CANCEL_UNSAVED_DATA: 'All your unsaved data will be lost. Please Confirm!',
  MOVE_NEXT_PAGE: 'Are you sure you want to move to another page?',
  TXN_DETAIL_LIST_TAB: [
    {
      label: 'OVERVIEW',
      key: 'overview',
    },
    {
      label: 'TASKS',
      key: 'tasks',
    },
    {
      label: 'EVENTS',
      key: 'events',
    },
  ],

  TXN_DETAIL_ASSET_TAB: [
    {
      label: 'Images',
      key: 'images',
    },
    {
      label: 'Documents',
      key: 'documents',
    },
  ],
  NO_DATA_MESSAGE: 'No Activity Found',
  TYPE: 'NO_USERS',
  NO_ASSETS_MESSAGE: 'No Assets Found',
  NO_TAGS_MESSAGE: 'No Tags Available',
  NO_COMMENTS_MESSAGE: 'No Comments Available',
  TXN_SUBMIT: 'SUBMIT',

  ASSERT: {
    DELETE_TITLE: 'Confirm Delete',
    DELETE_CONFIRM_MSG: 'Are you sure you want to delete this attachment?',
    OK_TEXT: 'DELETE',
    CANCEL: 'Cancel',
    DELETE_SUCCESS: 'The attachment has been successfully deleted',
    ADDED_SUCCESS: 'The attachment has been successfully added',
    UPDATED_SUCCESS: 'The attachment has been successfully updated',
  },
  SUB_FORM: {
    TITLE: 'SUB FORM',
    CREATE_DESC: 'Shall we go ahead and update this form ?',
    CREATE_OK: 'CONFIRM',
    CANCEL: 'Cancel',
    SUCCESS_MSG: 'form updated Successfully',
  },
  SERVICE_FORMS_TRANSACTION: {
    TITLE: 'Service Creation',
    UPDATE_TITLE: 'Service Update',
    CONFIRMATION_MSG: 'Shall we go ahead and create this transaction?',
    UPDATE_CONFIRMATION_MSG: 'Shall we go ahead and update this transaction?',
    UPDATE_CONFIRMATION_SUB_FORM_MSG: 'Shall we go ahead and update this form?',
    CREATE_CONFIRMATION_SUB_FORM_MSG: 'Shall we go ahead and create this form?',
    UPDATE_CONFIRMATION_DATA_MSG: 'Shall we go ahead and update?',
    SUCCESS_MSG: 'Created Successfully!',
    UPDATE_SUCCESS_MSG: 'Updated Successfully!',
  },
  TABLE_FORM: {
    TITLE: 'Are you sure?',
    OK: 'YES, REMOVE',
    CANCEL: 'Cancel',
    UPDATED_SUCCESS: 'Updated Successfully!',
    DELETE_SUCCESS: 'Deleted Successfully!',
    ADD_SUCCESS: 'Added Successfully!',
    TABLE_ROW_UPDATE: 'Table Rows Order Updated Successfully !',
  },
};

const chart = {
  CHART_COLORS: ['#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#FFCE54', '#FC6E51', '#ED5565', '#7523FF', '#FF6663', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9', '#09c', '#23D8FF', '#D25BFF', '#FF3E63', '#5D9CEC', '#4FC1E9'],
};

const permissions = {
  ROLES_AND_PERMISSION_ACCESS: {
    MY_BUSINESS: '/settings/my_business/',
    ACCOUNTS: '/settings/accounts/',
    PROFILE: '/settings/profile/',
    ACTIVITY: '/settings/activity/',
    MY_INVITEES: '/settings/my_invitees/',
    SERVICE: '/service/',
    TEAMS: '/teams/',
    CONSUMERS: '/consumers/',
  },
  ROLES_AND_PERMISSION_ACCESS_ACTIONS: {
    ALL: '*',
    READ: 'READ',
    CREATE: 'create',
  },
};

const colorsPalette = [
  'rgba(80, 227, 194)',
  'rgba(255, 102, 99)',
  'rgba(35, 216, 255)',
  'rgba(117, 35, 255)',
  'rgba(210, 91, 255)',
  'rgba(255, 152, 0, 1)',
  'rgba(93, 156, 236)',
  'rgba(77, 193, 233)',
  'rgba(160, 212, 104)',
  'rgba(255, 206, 84)',
  'rgba(252, 110, 81)',
  'rgba(237, 85, 101)',
];

const accountUserPerMission = {
  BUSINESS_ACCOUNTS: '/BUSINESS_ACCOUNTS/',
  BUSINESS_PROFILE_SETTINGS: '/BUSINESS_PROFILE_SETTINGS/',
  BUSINESS_MANAGEMENT: '/BUSINESS_MANAGEMENT/',
  BUSINESS_OPERATIONS: '/BUSINESS_OPERATIONS/',
  BUSINESS_SETTINGS: '/BUSINESS_SETTINGS/',
  BUSINESS_TEAMS: '/BUSINESS_TEAMS/',
  TEAM_DONT_HAVE_ACCESS_TO_UPDATE: "You don't have access to update these details.",
};

const accountUserPerMissionAction = {
  ALL: '*',
  READ: 'READ',
};

// Tasks List Tab View Items
const defaultTasksTabsViewItems = [
  {
    label: 'CLOSED',
    key: 'CLOSED',
  },
  {
    label: 'DUE',
    key: 'DUE',
  },
  {
    label: 'UPCOMING',
    key: 'UPCOMING',
  },
];

const tasksPriorityFilterSelectionList = [
  { id: 'Low', value: 'Low', key: 'Priority' },
  { id: 'Medium', value: 'Medium', key: 'Priority' },
  { id: 'High', value: 'High', key: 'Priority' },
];

const tasksStatusFilterSelectionList = [
  { id: 'Not Started', value: 'Not_Started', key: 'Status' },
  { id: 'In Progress', value: 'In_Progress', key: 'Status' },
  { id: 'Deferred', value: 'Deferred', key: 'Status' },
  { id: 'Completed', value: 'Completed', key: 'Status' },
  { id: 'Waiting', value: 'Waiting', key: 'Status' },
];

const taskStatusConstant = [
  {
    value: 'NOT_STARTED',
    label: 'Not Started',
  },
  {
    value: 'IN_PROGRESS',
    label: 'In Progress',
  },
  {
    value: 'DEFERRED',
    label: 'Deferred',
  },
  {
    value: 'COMPLETED',
    label: 'Completed',
  },
  {
    value: 'WAITING',
    label: 'Waiting',
  },
];

const taskPriorityConstant = [
  {
    value: 'LOW',
    label: 'Low',
  },
  {
    value: 'MEDIUM',
    label: 'Medium',
  },
  {
    value: 'HIGH',
    label: 'High',
  },
];

const taskDueTimeConstant = [
  {
    value: '00:00',
    label: '12:00 AM',
  },
  {
    value: '00:15',
    label: '12:15 AM',
  },
  {
    value: '00:30',
    label: '12:30 AM',
  },
  {
    value: '00:45',
    label: '12:45 AM',
  },
  {
    value: '01:00',
    label: '01:00 AM',
  },
  {
    value: '01:15',
    label: '01:15 AM',
  },
  {
    value: '01:30',
    label: '01:30 AM',
  },
  {
    value: '01:45',
    label: '01:45 AM',
  },
  {
    value: '02:00',
    label: '02:00 AM',
  },
  {
    value: '02:15',
    label: '02:15 AM',
  },
  {
    value: '02:30',
    label: '02:30 AM',
  },
  {
    value: '02:45',
    label: '02:45 AM',
  },
  {
    value: '03:00 AM',
    label: '03:00 AM',
  },
  {
    value: '03:15',
    label: '03:15 AM',
  },
  {
    value: '03:30',
    label: '03:30 AM',
  },
  {
    value: '03:45',
    label: '03:45 AM',
  },
  {
    value: '04:00',
    label: '04:00 AM',
  },
  {
    value: '04:15',
    label: '04:15 AM',
  },
  {
    value: '04:30',
    label: '04:30 AM',
  },
  {
    value: '04:45',
    label: '04:45 AM',
  },
  {
    value: '05:00',
    label: '05:00 AM',
  },
  {
    value: '05:15',
    label: '05:15 AM',
  },
  {
    value: '05:30',
    label: '05:30 AM',
  },
  {
    value: '05:45',
    label: '05:45 AM',
  },
  {
    value: '06:00',
    label: '06:00 AM',
  },
  {
    value: '06:15',
    label: '06:15 AM',
  },
  {
    value: '06:30',
    label: '06:30 AM',
  },
  {
    value: '06:45',
    label: '06:45 AM',
  },
  {
    value: '07:00',
    label: '07:00 AM',
  },
  {
    value: '07:15',
    label: '07:15 AM',
  },
  {
    value: '07:30',
    label: '07:30 AM',
  },
  {
    value: '07:45',
    label: '07:45 AM',
  },
  {
    value: '08:00',
    label: '08:00 AM',
  },
  {
    value: '08:15',
    label: '08:15 AM',
  },
  {
    value: '08:30',
    label: '08:30 AM',
  },
  {
    value: '08:45',
    label: '08:45 AM',
  },
  {
    value: '09:00',
    label: '09:00 AM',
  },
  {
    value: '09:15',
    label: '09:15 AM',
  },
  {
    value: '09:30',
    label: '09:30 AM',
  },
  {
    value: '09:45',
    label: '09:45 AM',
  },
  {
    value: '10:00',
    label: '10:00 AM',
  },
  {
    value: '10:15',
    label: '10:15 AM',
  },
  {
    value: '10:30',
    label: '10:30 AM',
  },
  {
    value: '10:45',
    label: '10:45 AM',
  },
  {
    value: '11:00',
    label: '11:00 AM',
  },
  {
    value: '11:15',
    label: '11:15 AM',
  },
  {
    value: '11:30',
    label: '11:30 AM',
  },
  {
    value: '11:45',
    label: '11:45 AM',
  },
  {
    value: '12:00',
    label: '12:00 PM',
  },
  {
    value: '12:15',
    label: '12:15 PM',
  },
  {
    value: '12:30',
    label: '12:30 PM',
  },
  {
    value: '12:45',
    label: '12:45 PM',
  },
  {
    value: '13:00',
    label: '01:00 PM',
  },
  {
    value: '13:15',
    label: '01:15 PM',
  },
  {
    value: '13:30',
    label: '01:30 PM',
  },
  {
    value: '13:45',
    label: '01:45 PM',
  },
  {
    value: '14:00',
    label: '02:00 PM',
  },
  {
    value: '14:15',
    label: '02:15 PM',
  },
  {
    value: '14:30',
    label: '02:30 PM',
  },
  {
    value: '14:45',
    label: '02:45 PM',
  },
  {
    value: '15:00',
    label: '03:00 PM',
  },
  {
    value: '15:15',
    label: '03:15 PM',
  },
  {
    value: '15:30',
    label: '03:30 PM',
  },
  {
    value: '15:45',
    label: '03:45 PM',
  },
  {
    value: '16:00',
    label: '04:00 PM',
  },
  {
    value: '16:15',
    label: '04:15 PM',
  },
  {
    value: '16:30',
    label: '04:30 PM',
  },
  {
    value: '16:45',
    label: '04:45 PM',
  },
  {
    value: '17:00',
    label: '05:00 PM',
  },
  {
    value: '17:15',
    label: '05:15 PM',
  },
  {
    value: '17:30',
    label: '05:30 PM',
  },
  {
    value: '17:45',
    label: '05:45 PM',
  },
  {
    value: '18:00',
    label: '06:00 PM',
  },
  {
    value: '18:15',
    label: '06:15 PM',
  },
  {
    value: '18:30',
    label: '06:30 PM',
  },
  {
    value: '18:45',
    label: '06:45 PM',
  },
  {
    value: '19:00',
    label: '07:00 PM',
  },
  {
    value: '19:15',
    label: '07:15 PM',
  },
  {
    value: '19:30',
    label: '07:30 PM',
  },
  {
    value: '19:45',
    label: '07:45 PM',
  },
  {
    value: '20:00',
    label: '08:00 PM',
  },
  {
    value: '20:15',
    label: '08:15 PM',
  },
  {
    value: '20:30',
    label: '08:30 PM',
  },
  {
    value: '20:45',
    label: '08:45 PM',
  },
  {
    value: '21:00',
    label: '09:00 PM',
  },
  {
    value: '21:15',
    label: '09:15 PM',
  },
  {
    value: '21:30',
    label: '09:30 PM',
  },
  {
    value: '21:45',
    label: '09:45 PM',
  },
  {
    value: '22:00',
    label: '10:00 PM',
  },
  {
    value: '22:15',
    label: '10:15 PM',
  },
  {
    value: '22:30',
    label: '10:30 PM',
  },
  {
    value: '22:45',
    label: '10:45 PM',
  },
  {
    value: '23:00',
    label: '11:00 PM',
  },
  {
    value: '23:15',
    label: '11:15 PM',
  },
  {
    value: '23:30',
    label: '11:30 PM',
  },
  {
    value: '23:45',
    label: '11:45 PM',
  },
];

const tasksConstant = {
  TAKS_HEADEING: 'Tasks',
  TASKS_TABS: {
    CLOSED: 'CLOSED',
    DUE: 'DUE',
    UPCOMING: 'UPCOMING',
  },
  NO_TASKS_TEXT: 'No Tasks available to display!',
  NO_TXN_SERVICE_TEXT: 'No Service',
  TASKS_FILTER_MODAL: {
    HEADING: 'Filters',
    SUB_HEADING: 'Applying filters',
    CLEAR_BUTTON: 'CLEAR ALL',
    APPLY_BUTTON: 'APPLY',
    Fiters: {
      PRIORITY: 'Priority',
      PRIORITY_ITEMS: {
        LOW: 'LOW',
        MEDIUM: 'MEDIUM',
        HIGH: 'HIGH',
      },
      STATUS: 'Status',
      STATUS_ITEMS: {
        NOT_STARTED: 'Not Started',
        IN_PROGRESS: 'In Progress',
        DEFERRED: 'Deferred',
        COMPLETED: 'Completed',
        WAITING: 'Waiting',
      },
      APPS: 'Apps',
      ASSIGNEE: 'Assignee',
    },
  },
  TASKS_DROPDOWN_FILTERS: {
    DONE: 'Done',
    CHANGE_STATUS: 'Change Status',
    CHANGE_ASSIGNEE: 'Change Assignee',
    CHANGE_PRIORITY: 'Change Priority',
    CHANGE_DATE_TIME: 'Change Date and Time',
    VIEW_TRANSACTIONS: 'View Transactions',
    COMMENTS: 'Comments',
    ATTACHMENTS: 'Attachments',
    ACTIVITY: 'Activity',
    EDIT: 'Edit',
  },
  TASKS_UPDATED_TEXT: 'Task Updated Successfully!',
  DROPDOWN_MODALS: {
    DONE_TEXT: 'Are you done with this task?',
    STATUS_HEADING: 'Status',
    ASSIGNEE_HEADING: 'Assignee',
    PRIORITY_HEADING: 'Priority',
    DUE_DATE_HEADING: 'Due Date',
    DUE_TIME_HEADING: 'Due Time',
    LINKED_TRANSACTION: 'LINKED TRANSACTION',
    COMMENTS_HEADING: 'COMMENTS',
    ATTACHMENTS_HEADING: 'ATTACHMENTS',
    ACTIVITY_HEADING: 'ACTIVITY',
    SELECT_PERSPECTIVE_MODAL: {
      HEADING: 'Perspectives',
      SELECT_PERSPECTIVE_TEXT: 'Select below any Perspective to view the details.',
      DONE_BUTTON: 'Done',
      NO_ACCESS_TEXT: 'You dont have access to view/update these details.',
    },
    NO_ATTACHMENT_TEXT: 'No attachments available',
  },
  EDIT_TASK_MODAL: {
    HEADER: {
      CHANGE_USER_HEADING: 'Users',
      CHANGE_USER_ERROR_MSG: 'Please choose different user',
      CHANGE_USER_CONFIRM_TITLE: 'ARE YOU SURE?',
      CHANGE_USER_CONFIRM_MSG: 'Do you want to change to this assignee?',
      CHANGE_TEXT: 'Change',
      NOTIFY_TEXT: 'NOTIFY',
      SAVE_BUTTON: 'SAVE',
    },
    EDIT_TASK_FORM: {
      TASK_NAME: {
        HEADING: 'Task',
        PLACEHOLDER: 'Enter Name Here..',
      },
      TASK_DESCRIPTION: {
        HEADING: 'Description',
        PLACEHOLDER: 'Enter Description Here..',
      },
      TASK_DUE_DATE: {
        HEADING: 'Due Date',
        PLACEHOLDER: 'Select Due Date',
      },
      TASK_DUE_TIME: {
        HEADING: 'Due Time',
        PLACEHOLDER: 'Due Time',
      },
      TASK_PRIORITY: {
        HEADING: 'Priority',
        PLACEHOLDER: 'Choose Priority',
      },
      TASK_STATUS: {
        HEADING: 'Status',
        PLACEHOLDER: 'Choose Status',
      },
    },
  },
  CREATE_TASK_MODAL: {
    HEADER: {
      HEADING: 'Create New Task',
      SUB_HEADING: 'Create New task on create, update or delete a transaction',
      NOTIFY_TEXT: 'NOTIFY',
      SAVE_BUTTON: 'SAVE',
    },
    CREATE_TASK_FORM: {
      TASK_NAME: {
        HEADING: 'Name',
        PLACEHOLDER: 'Enter Name Here..',
      },
      TASK_ASSIGNEE: {
        HEADING: 'Assignee',
        PLACEHOLDER: 'Choose Assignee..',
      },
      TASK_DESCRIPTION: {
        HEADING: 'Description',
        PLACEHOLDER: 'Enter Description Here..',
      },
      TASK_DUE_DATE: {
        HEADING: 'Due Date',
        PLACEHOLDER: 'Due Date',
      },
      TASK_DUE_TIME: {
        HEADING: 'Due Time',
        PLACEHOLDER: 'Due Time',
      },
      TASK_PRIORITY: {
        HEADING: 'Priority',
        PLACEHOLDER: 'Choose Priority',
      },
      TASK_STATUS: {
        HEADING: 'Status',
        PLACEHOLDER: 'Choose Status',
      },
    },
    SUCCESS_MSG: 'Created Successfully!',
  },
};

const hooperLinks = {
  HOOPER_LINKS: {
    ABOUT: 'https://www.hooperlabs.com/company/about',
    TERMS: 'https://pro.hooperlabs.com/web/#/terms',
    PRIVACY: 'https://pro.hooperlabs.com/web/#/privacy',
    DISCLAIMER: 'https://pro.hooperlabs.com/web/#/security',
    COMPLIANCE: 'https://pro.hooperlabs.com/web/#/compliance',
  },
};
const dataImportConstant = {
  TITLE: 'New Data Import (CSV/Excel)',
  FILE: 'Pick CSV or Excel file from a local Folders',
  FILE_HEADER: 'Use First Row as Header',
  TXN_UPDATE: 'Update Existing Transactions Based On',
  PLACEHOLDER: 'Enter name here...',
  FIELD_MAPPING_TITLE: 'New Data Import (CSV/Excel) - Field Mapping',
};

const publicForms = {
  TCPL_OBSERVATION_FORM_END_POINT: 'https://prok.kellton.net/api/hook/66f12a21c49e274dd78a3be1',
  TCPL_OBSERVATION_FORM_REST_HOOK_TOKEN: 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI2NmY2NzMzZGM0OWUyNzRkZDc4YWQ0MDkiLCJleHAiOjE4OTM1NDIzNDAsImlhdCI6MTcyNzM5NTIwMH0.1ZotY4h8MLYV2BchI8lyRq-Kn_bA-p9UGDNDYHJiF_mh6xlK-zUY7iwYBg1cXYnGlmiihZFlhjNWCYJoDQBcRg',
  TCPL_PUBLIC_FORM_END_POINT: 'https://prok.kellton.net/api/hook/670f62b8c49e275e8727b0ce',
  TCPL_PUBLIC_FORM_REST_HOOK_TOKEN: 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI2NzBmYWUxMmM0OWUyNzVlODcyN2JiYjYiLCJleHAiOjE4OTM1NDIzNDAsImlhdCI6MTcyOTAzNjgwMH0.sXdsPbkwgsW7bB3PZnLEaDq2IoAAWJSIRc_QNHxKZfu8hOx8zP3-el5bAhKuh0BH9x-yiMYxIsleRy7yV8B3_A'
}

const googleCaptcha = {
  PROD_SITE_KEY: '6LeoWW8qAAAAAFctXWokeNypEHJit5nERitHMDNr',
  STG_SITE_KEY: '6Lc82GoqAAAAAPjEcpkd1tLDQ4_FJzDwJ9AvXpGi',

}

export {
  reportConstant,
  signInConstant,
  forgotPasswordConstant,
  regexPattern,
  registerBusiness,
  otpConstant,
  accountsConstant,
  teamsConstant,
  buttonText,
  activityConstant,
  dashboardConstant,
  appPageConstant,
  mapConstant,
  flowsConstant,
  form,
  templates,
  comments,
  googleMapApiKey,
  googleMapBaseUrl,
  lookup,
  // reportConstant,
  transactionConstant,
  appsSettingsConstant,
  notificationsConstant,
  messageConstant,
  changeBusinessConstant,
  businessProfileConstant,
  txnForm,
  chart,
  permissions,
  colorsPalette,
  accountUserPerMission,
  accountUserPerMissionAction,
  defaultTasksTabsViewItems,
  tasksStatusFilterSelectionList,
  tasksPriorityFilterSelectionList,
  taskStatusConstant,
  taskPriorityConstant,
  taskDueTimeConstant,
  tasksConstant,
  hooperLinks,
  dataImportConstant,
  publicForms,
  googleCaptcha
};
